export default __webpack_public_path__ + "static/gallery-award-americanvisions-544766510a2ba2b64605d94bf21ee950.jpg";